import { breakpoints } from "@xcorejs/ui";

export const breakpointsTheme = breakpoints(
  ["22.5em", "30em", "48em", "63.99em", "78em", "85em", "94em"],
  ["xxs", "xs", "sm", "md", "lg", "xl", "xxl"]
);
